



















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import VueUploadMultipleImage from 'vue-upload-multiple-image';
import CarEntity from '@/entities/Car';
import CarService from '@/services/car';
import Icon from '@/components/Icon.vue';
import FloatLabelInput from '@/components/FloatLabelInput.vue';
import Picture from '@/entities/Picture';
import variables from '@/support/variables';
import CarOption from '@/entities/CarOption';
import PictureService from '@/services/picture';

@Component({
  components: {
    FloatLabelInput,
    Icon,
    VueUploadMultipleImage,
  },
})
export default class Car extends Vue {
  carService = new CarService();

  pictureService = new PictureService();

  car: CarEntity = null;

  fetchedSelectOptions: any = null;

  loadUploader = true;

  showPicturesSorting = false;

  sortedItems: any = null;

  status: string = null;

  numberOfImagesBeingProcessed = 0;

  statuses = [
    { name: 'Verkocht', value: 'sold' },
    { name: 'Gereserveerd', value: 'reserved' },
  ];

  bodyTypes = [
    'Stadswagen',
    'Cabriolet',
    'Coupé',
    'SUV',
    'Berline',
    'Break',
    'Bestelwagen',
    'Monovolume',
  ];

  get variables() {
    return variables;
  }

  get thumbnails(): string[] {
    const end = this.car.pictures.length < 5 ? this.car.pictures.length : 5;

    return this.car.pictures
      .slice(1, end)
      .map((picture: Picture) => picture.thumb320Url);
  }

  get selectOptions(): any {
    if (!this.fetchedSelectOptions) {
      this.fetchSelectOptions();
    }

    return this.fetchedSelectOptions || [];
  }

  get carOptionsSplitted(): any[] {
    const index = Math.floor(this.selectOptions.options.length / 3);

    return [
      this.selectOptions.options.slice(0, index),
      this.selectOptions.options.slice(index + 1, index * 2),
      this.selectOptions.options.slice(index * 2 + 1),
    ];
  }

  mounted() {
    if (this.$route.params.id) {
      this.carService.get(this.$route.params.id)
        .then((car: CarEntity) => {
          this.car = car;
          if (this.car.isReserved) {
            this.status = 'reserved';
          } else if (this.car.isSold) {
            this.status = 'sold';
          }
        });
    } else {
      this.car = new CarEntity();
    }

    this.fetchSelectOptions();
  }

  uploadImageSuccess(formData: any, index: any, fileList: any) {
    this.numberOfImagesBeingProcessed += 1;
    this.pictureService.uploadData(fileList[index].path, fileList[index].name, 'cars')
      .then((picture: Picture) => {
        this.car.addPicture(picture);
      })
      .finally(() => {
        this.numberOfImagesBeingProcessed -= 1;
      });
  }

  fetchSelectOptions() {
    this.carService.get(this.$route.params.id)
      .then((car: CarEntity) => {
        this.car = car;
      });

    this.carService.props().then((options: CarOption[]) => {
      this.fetchedSelectOptions = options;
    });
  }

  save() {
    this.carService.save(this.car)
      .then((car) => {
        this.$nextTick(() => this.$router.replace({
          name: 'Cars',
        }));
      });
  }

  orderChanged(sorted: any) {
    this.sortedItems = sorted.items;
  }

  @Watch('numberOfImagesBeingProcessed')
  reloadUploader(numberOfImagesBeingProcessed: number) {
    if (numberOfImagesBeingProcessed === 0) {
      this.loadUploader = false;

      this.$nextTick(() => {
        this.loadUploader = true;
      });
    }
  }

  @Watch('showPicturesSorting')
  populateOrder(showPicturesSorting: boolean) {
    if (!showPicturesSorting && this.sortedItems) {
      this.$nextTick(() => {
        this.car.pictures = this.sortedItems.map((item: any) => {
          const picture = item.item;
          picture.position = item.sort + 1;
          return picture;
        });
        this.sortedItems = null;
      });
    }
  }

  @Watch('status')
  statusChanged(status: string) {
    if (status === 'sold') {
      this.car.isSold = true;
      this.car.isReserved = false;
    } else if (status === 'reserved') {
      this.car.isSold = false;
      this.car.isReserved = true;
    } else {
      this.car.isSold = false;
      this.car.isReserved = false;
    }
  }
}
